import { Component } from '@verndale/core';

class References extends Component {
  setupDefaults() {
    this.citations = [];
    this.referencesContainer = this.el.querySelector('ol');
    this.setupReferences();
    this.addListeners();
  }

  setupReferences() {
    // Find all citations on the page
    const citationElements = document.querySelectorAll(
      '[data-module="citation"]'
    );

    // Clear existing citations
    this.citations = [];

    citationElements.forEach((citationEl) => {
      const citationText = citationEl.querySelector('.citation__text');
      const supElement = citationEl.querySelector('sup');

      if (citationText && supElement) {
        const number = supElement.textContent.replace(/[[\]]/g, ''); // Remove brackets
        const text = citationText.innerHTML
          .trim()
          .replace(/<sup>\[\d+\]<\/sup>/g, ''); // Remove <sup>[number]</sup> tags but keep other HTML

        // Check if this citation number already exists
        const existingCitation = this.citations.find(
          (c) => c.number === parseInt(number, 10)
        );

        if (existingCitation) {
          // If citation with same number exists, add this text to the existing one
          if (!existingCitation.texts.includes(text)) {
            existingCitation.texts.push(text);
          }
        } else {
          // Create new citation with texts array
          this.citations.push({
            number: parseInt(number, 10),
            texts: [text],
            element: citationEl
          });
        }
      }
    });

    // Sort citations by sup number
    this.citations.sort((a, b) => a.number - b.number);

    this.renderReferences();
  }

  renderReferences() {
    if (!this.referencesContainer) return;

    // Hide the entire references component if no citations exist
    if (this.citations.length === 0) {
      this.hideReferences();
      return;
    }

    // Show the references component
    this.showReferences();

    // Clear existing references
    this.referencesContainer.innerHTML = '';

    // Create reference list items
    this.citations.forEach((citation) => {
      const listItem = document.createElement('li');
      // Join multiple texts with commas
      const combinedText = citation.texts;
      listItem.innerHTML = `
          <span class="reference-number">${citation.number}</span>
          <span class="reference-text">${combinedText[0]}</span>
        `;
      this.referencesContainer.appendChild(listItem);
    });
  }

  // Method to add a new citation dynamically
  addCitation(number, text) {
    const existingCitation = this.citations.find((c) => c.number === number);

    if (existingCitation) {
      // If citation with same number exists, add this text to the existing one
      if (!existingCitation.texts.includes(text)) {
        existingCitation.texts.push(text);
        this.renderReferences();
      }
    } else {
      // Create new citation with texts array
      this.citations.push({
        number,
        texts: [text],
        element: null
      });

      // Re-sort and re-render
      this.citations.sort((a, b) => {
        const numA = parseInt(a.number, 10);
        const numB = parseInt(b.number, 10);
        return numA - numB;
      });

      this.renderReferences();
    }
  }

  // Method to remove a citation
  removeCitation(number) {
    this.citations = this.citations.filter((c) => c.number !== number);
    this.renderReferences();
  }

  // Method to update a citation
  updateCitation(number, newText) {
    const citation = this.citations.find((c) => c.number === number);
    if (citation) {
      // Replace all texts with the new text
      citation.texts = [newText];
      this.renderReferences();
    }
  }

  // Method to hide the entire references component
  hideReferences() {
    if (this.el) {
      this.el.style.display = 'none';
    }
  }

  // Method to show the entire references component
  showReferences() {
    if (this.el) {
      this.el.style.display = '';
    }
  }
}

export default References;
